import { MEMBER_ACCOUNT_ACTIVE_STATUSES } from "constants/v3/generalConstants";

export function findValueByKey(obj: unknown, key: string): unknown | null {
  if (obj == null || typeof obj !== "object") {
    return null;
  }
  if (Array.isArray(obj)) {
    for (const item of obj) {
      const found = findValueByKey(item, key);
      if (found != null) return found;
    }
    return null;
  }
  const record = obj as Record<string, unknown>;
  if (Object.prototype.hasOwnProperty.call(record, key)) {
    return record[key];
  }
  for (const value of Object.values(record)) {
    const found = findValueByKey(value, key);
    if (found != null) return found;
  }
  return null;
}

/**
 * True when the Auth0 ID token includes a non-empty `glMemberStatus` claim.
 * Unpaid-invitee sessions omit this claim until a plan status exists in the identity provider.
 */
export function idTokenHasGlMemberStatus(claims: unknown): boolean {
  const raw = findValueByKey(claims, "glMemberStatus");
  if (raw == null) return false;
  if (typeof raw === "string") return raw.trim() !== "";
  return true;
}

export function getIsMemberActiveFromIdTokenClaims(claims: unknown): boolean {
  const raw = findValueByKey(claims, "glMemberStatus");
  const glMemberStatus = typeof raw === "string" ? raw : "";
  return MEMBER_ACCOUNT_ACTIVE_STATUSES.includes(
    glMemberStatus.replace(/[,/\-\s']/g, "").toUpperCase()
  );
}

function getBooleanClaimFromIdToken(claims: unknown, key: string): boolean {
  const raw = findValueByKey(claims, key);
  if (raw === true) {
    return true;
  }
  if (raw === false) {
    return false;
  }
  if (typeof raw === "string") {
    const normalized = raw.trim().toLowerCase();
    return normalized === "true" || normalized === "1";
  }
  return false;
}

export type ShareEligibilityFromIdToken = {
  eligibleToGift: boolean;
  eligibleToInvite: boolean;
};

export function getShareEligibilityFromIdTokenClaims(
  claims: unknown
): ShareEligibilityFromIdToken {
  return {
    eligibleToGift: getBooleanClaimFromIdToken(claims, "eligibleToGift"),
    eligibleToInvite: getBooleanClaimFromIdToken(claims, "eligibleToInvite")
  };
}
